import { AppServerAPI } from '@sdbn/common'
import { Injectable } from '@angular/core'
import { Subject } from 'rxjs';
import { ListResult } from '@sdbn/common-essential'

import { TransportColoringTheme } from "./transportvisualization.model"

@Injectable({
    providedIn: 'root'
})
export class TransportColoringThemeAdministrationAPIService {

  constructor (
    private appServerAPI: AppServerAPI
  ) {
  }

  public save(coloringTheme: TransportColoringTheme) : Subject<boolean> {
    const subject = new Subject<boolean>();
    this.appServerAPI.execute<boolean>('/TMC-YARD/TransportVisualization/TransportColoringThemeAdministration/save', coloringTheme).subscribe(response => {
      subject.next( response);
    },
      error => {
        subject.error(error);
      }
    );
    return subject;
  }

  public delete(theme: TransportColoringTheme) : Subject<boolean> {
    const subject = new Subject<boolean>();
    this.appServerAPI.execute<boolean>('/TMC-YARD/TransportVisualization/TransportColoringThemeAdministration/delete', theme).subscribe(response => {
      subject.next( response);
    },
      error => {
        subject.error(error);
      }
    );
    return subject;
  }

  public getAll() : Subject<ListResult<TransportColoringTheme>> {
    const subject = new Subject<ListResult<TransportColoringTheme>>();
    this.appServerAPI.execute<ListResult<TransportColoringTheme>>('/TMC-YARD/TransportVisualization/TransportColoringThemeAdministration/getAll', null).subscribe(response => {
      let result = new Array<TransportColoringTheme>();
      for (const item of response.values) {
        result.push(new TransportColoringTheme(item));
      }
      subject.next(new ListResult<TransportColoringTheme>(result, response.dataSetCount));
    },
      error => {
        subject.error(error);
      }
    );
    return subject;
  }

  public get(id: string) : Subject<TransportColoringTheme> {
    const subject = new Subject<TransportColoringTheme>();
    this.appServerAPI.execute<TransportColoringTheme>('/TMC-YARD/TransportVisualization/TransportColoringThemeAdministration/get', id).subscribe(response => {
      subject.next( new TransportColoringTheme(response));
    },
      error => {
        subject.error(error);
      }
    );
    return subject;
  }

}
